const config = {
  API_BASE_URL: "https://api.digidoc.co.in"
};

export default config;
  